const skin = {
	topLayout:"space",
	//bar in accordion
	barHeight:36,			//!!!Set the same in skin.less!!!
	tabbarHeight: 34,
	sidebarTitleHeight: 36,
	rowHeight:28,
	toolbarHeight:36,
	listItemHeight:28,	//list, grouplist, dataview, etc.
	inputHeight: 30,
	buttonHeight: 30,
	inputPadding: 3,
	menuHeight: 28,
	labelTopHeight: 16,
	propertyItemHeight: 24,
	unitHeaderHeight:28,
	timelineItemHeight:50,

	inputSpacing: 4,
	borderWidth: 1,

	sliderHandleWidth: 12,
	sliderPadding: 10,
	sliderBorder: 1,
	vSliderPadding:13,
	vSliderHeight:100,
	switchHeight:22,
	switchWidth:40,

	//margin - distance between cells
	layoutMargin:{ space:5, wide:5, clean:0, head:4, line:-1, toolbar:4, form:8, accordion: 2  },
	//padding - distance inside cell between cell border and cell content
	layoutPadding:{ space:5, wide:0, clean:0, head:0, line:0, toolbar:2, form:12, accordion: 0  },
	//space between tabs in tabbar
	tabMargin: 0,
	tabOffset: 0,
	tabBottomOffset: 0,
	tabTopOffset:0,
	tabBorder: true,

	customCheckbox: true,
	customRadio: true,
	sidebarMarkAll: true,
	popupNoPoint: true,
	borderlessPopup: true,

	popupPadding: 0,

	dataPadding: 12,

	calendarWeekHeaderHeight: 18,
	padding:0,
	accordionType: "accordion",

	optionHeight: 24,
	timelineColor:"#1CA1C1",

	backColor:"#FFFFFF",
	dataBorderColor:"#EDEFF0",

	//colorboard
	colorPadding: 4
};

export default skin;
